import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 启用状态
 */
class Able extends UltMeta {
    ENABLE = new Meta(1, "已启用");
    DISABLE = new Meta(0, "已禁用", "color-info");
}

export const ABLE = new Able();

/**
 * 启用状态
 */
class RegularAble extends UltMeta {
    ENABLE = new Meta(0, "已启用");
    DISABLE = new Meta(1, "已禁用", "color-info");
}

export const REGULAR_ABLE = new RegularAble();

/**契约锁签署类型 1是pc 2是小程序 */
class SignOrigin extends UltMeta {
    PC = new Meta(1, "PC");
    WX = new Meta(2, "小程序");
}
export const SIGN_ORIGIN = new SignOrigin();

/**
 * 排序
 */
class Sort extends UltMeta {
    ASC = new Meta("ascending", "asc", 1);
    DESC = new Meta("descending", "desc", 0);
}

export const SORT = new Sort();

/**
 * 连接状态
 */
class WebSocketReadyState extends UltMeta {
    CONNECTING = new Meta(0, "正在链接中");
    OPEN = new Meta(1, "已经链接并且可以通讯");
    CLOSING = new Meta(2, "连接正在关闭");
    CLOSED = new Meta(3, "连接已关闭或者没有链接成功");
}
export const WEBSOCKET_READY_STATE = new WebSocketReadyState();

/**
 * 页面类型
 */
class PageType extends UltMeta {
    LIST = new Meta(0, "列表");
    DETAIL = new Meta(1, "详情");
    LOG = new Meta(2, "记录");
    /**
     * 缓存表单页
     * 缓存的表单页提交成功后要调用 keepAliveStore.deleteCacheForm() 来删除缓存
     **/
    CACHE_FORM = new Meta(3, "表单");
}
export const PAGE_TYPE = new PageType();

/**
 * 签署方式
 */
class SignType extends UltMeta {
    ONLINE = new Meta(1, "线上");
    OFFLINE = new Meta(2, "线下");
}

export const SIGN_TYPE = new SignType();
